import { render } from "./TSMPage.vue?vue&type=template&id=00748b6b"
import script from "./TSMPage.vue?vue&type=script&lang=js"
export * from "./TSMPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__